export default "__VITE_ASSET__Bs1tW9Qg__"